import { Loading } from "components/shared";
import React, { useEffect } from "react";
import useMagicAction, { RESULT_SCHEMA, asText } from "./useMagicAction";


const TranslateTo = ({ langTo, ...props }) => {

    const { run, input, writeBackReplace, closeMenu } = useMagicAction(props);

    useEffect(() => {
        run({
            prompt: `Translate the following text to ${langTo}. Preserve meaning, tone, emojis, hashtags and URLs.\n\nTEXT:\n${input}`,
            schema: RESULT_SCHEMA,
            // Override the company-language directive so the result is in the
            // requested target language, not the brand's default language.
            system: `For this task only, ignore any instruction about the default company language. Output the result strictly in ${langTo}, regardless of the input language.`,
        })
            .then((r) => writeBackReplace(asText(r)))
            .finally(closeMenu);
    }, []);

    return (
        <div className="flex items-center justify-center p-4 gap-2">
            <Loading type={'element'} />
        </div>
    )
}

export default TranslateTo;
